import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { defineStore } from 'pinia'
import timezone from 'dayjs/plugin/timezone'

import { store } from '@/store/index'
import { APPORTION_DEPARTMENT } from '../ts/constant'
import { arrayIsNotEmpty, transformUtcByTimezone } from '../utils/PublicMethods'

dayjs.extend(utc)
dayjs.extend(timezone)

// 用sort_num字段对表格数据排序
const sortTable = (input) => {
  let target = JSON.parse(JSON.stringify(input))
  target = target.sort((prev, next) => {
    return prev.sort_num - next.sort_num
  })
  return target
}

export const useLocaleStore = defineStore({
  id: 'ecowatch_ecowatch',

  state: (): any => ({
    role: {},
    locationValue: '',
    areaValue: {
      grade: 4,
      groupId: 567,
      label: '',
      orgId: 1,
      parentId: '',
      type: 'node',
      value: '',
      key: ''
    },
    formInline: {
      areaLevel: '',
      grouplev: [],
      energylev: [],
      typeCategories: [],
      interval: 'day',
      time: [
        new Date(new Date().getFullYear(), new Date().getMonth()),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1)
      ],
      compareWay: 1,
      amortized: 0,
      convert: 1,
      statisticValue: 'product'
    },
    classifyValue: '',
    locationOptions: [],
    locationOptionsDynamic: [],
    locationKPIOptions: [],
    classifyOptions: [],
    interval: '',
    beginTime: '',
    endTime: '',
    // 保存初始树结构多选默认选中的节点 解决从其他页面进入对多象高亮与默认选中不对应
    defaultCheckArr: [],
    translateType: '',
    matrixingType: '',
    // 能耗排名是否显示同环比
    showYoYMoM: true,
    // 用能总览区域
    locationUsedOptions: [],
    // 群组通知
    infoOptions: [],
    // 时区
    timezone: '',
    dayOfStart: '',
    // 年区间
    yearRange: {
      beginTime: '',
      endTime: ''
    } as any,
    unitText: 'echarts.empty',
    multiDate: [],
    timeTypeMultiple: 'date',
    intervalMultiple: 'hour',
    // 分摊
    factoryOptions: [],
    sharingFactoryValue: '',
    sharingFactoryName: '',
    sharingSubitemOptions: [],
    sharingSubitemValue: '',
    sharingTimeValue: '',
    productionLineList: [],
    workSectionOptions: [],
    // 当前编辑的表计用量所有数据
    currentMeterUsageData: {},
    // mis系统的能源管理部门
    misOptions: [],
    ecoOrgId: 1,
    outPutUnit: [],
    priceUnit: [],
    // 配置页面的区域value
    configAreaValueObj: {},
    // 同步资产组
    needSyncGroup: true
  }),

  getters: {
    // 偏移量获取
    dayOfStartAfter() {
      if (this.dayOfStart) {
        // 时区不可能为空，只要有资产组就有时区
        const daOfStartBefore = this.dayOfStart.split(':')
        const daOfStart =
          (Number(daOfStartBefore[0]) * 60 * 60 +
            Number(daOfStartBefore[1]) * 60 +
            Number(daOfStartBefore[2])) *
          1000

        return daOfStart
      }

      return 0
    },

    // 小时偏移量,向上取整
    dayOfStartHour() {
      if (this.dayOfStart) {
        // 时区不可能为空，只要有资产组就有时区
        const daOfStartBefore = this.dayOfStart.split(':')
        let hour = Number(daOfStartBefore[0])
        const minute = Number(daOfStartBefore[1])
        const second = Number(daOfStartBefore[2])
        if (minute > 0 || second > 0) {
          hour++
        }
        const daOfStart = hour * 60 * 60 * 1000

        return daOfStart
      }

      return 0
    },

    // 分钟偏移量,向前取15分钟的整数倍
    dayOfStartMinute() {
      if (this.dayOfStart) {
        // 时区不可能为空，只要有资产组就有时区
        const daOfStartBefore = this.dayOfStart.split(':')
        const hour = Number(daOfStartBefore[0])
        const minute = Number(daOfStartBefore[1])
        const minuteAfter = parseInt(minute / 15 + '') * 15
        const daOfStart = (hour * 60 * 60 + minuteAfter * 60) * 1000

        return daOfStart
      }

      return 0
    },

    // 偏移量获取-整点
    wholePointOffset() {
      if (this.dayOfStart) {
        // 时区不可能为空，只要有资产组就有时区
        const daOfStartBefore = this.dayOfStart.split(':')
        const daOfStart = Number(daOfStartBefore[0])

        return daOfStart
      }

      return 0
    },

    // 偏移量获取-分钟
    minutePointOffset() {
      let target = 0

      if (this.dayOfStart) {
        // 时区不可能为空，只要有资产组就有时区
        const daOfStartBefore = this.dayOfStart.split(':')
        const daOfStart = Number(daOfStartBefore[1])
        target = daOfStart ? daOfStart : 0
      }

      return target
    },

    timezoneAfter() {
      if (this.timezone) {
        // 时区不可能为空，只要有资产组就有时区
        const timezoneBefore = dayjs.tz(new Date(), this.timezone)
        const offset = timezoneBefore.utcOffset() / 60

        return offset
      }

      return 0
    },
    classifyValue2Item() {
      const target = {}
      const _classifyOptions = this.classifyOptions
      if (arrayIsNotEmpty(_classifyOptions)) {
        this.fnEachClassifyOptions(_classifyOptions, target)
      }
      return target
    },
    unit() {
      return this.classifyValue2Item[this.classifyValue]?.unit || ''
    },
    getDefaultCheckArr(): any {
      return this.defaultCheckArr
    },
    getAreaValue(): any {
      return this.areaValue
    },
    getFormInline(): any {
      return this.formInline
    },
    areaValue2AllValue({ locationOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.value] = val
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(locationOptions)
      return target
    },
    locationOptionsTarget({ locationOptions }) {
      const locationOptionsTarget = JSON.parse(JSON.stringify(locationOptions))
      function fnHandleLocationDisabled(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.grade === 1) {
              val.disabled = true
            } else {
              val.disabled = false
            }

            if (val.children && val.children.length) {
              fnHandleLocationDisabled(val.children)
            }
          })
        }
      }
      fnHandleLocationDisabled(locationOptionsTarget)
      return locationOptionsTarget
    },

    locationLabelAfterTransform({ locationOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.value] = val.label
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(locationOptions)
      return target
    },

    // 判断节点是否是根节点
    locationNodeIsRoot({ locationOptions }) {
      const target = {}
      locationOptions.forEach(({ value }) => {
        if (value) {
          target[value] = true
        }
      })
      return target
    },

    // 获取所选节点的子节点value-特殊
    getLocationChildNodeSpecial({ locationOptionsDynamic }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = val.children.map((innerVal) => innerVal.value)
              fnValue2Label(val.children)
            } else {
              target[val.value] = [val.value]
            }
          })
        }
      }
      fnValue2Label(locationOptionsDynamic)
      return target
    },

    locationLabelAfterTransformSpecial({ locationOptionsDynamic }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.value] = val.label
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(locationOptionsDynamic)
      return target
    },

    locationValue2ApmOrgIdSpecial({ locationOptionsDynamic }) {
      const target = {}
      function fnTransformApmOrgId(options, apmOrgId) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!apmOrgId) {
              target[val.value] = val.apm_org_id
            } else {
              target[val.value] = apmOrgId
            }
            fnTransformApmOrgId(val.children, target[val.value])
          })
        }
      }
      fnTransformApmOrgId(locationOptionsDynamic, '')
      return target
    },

    classifyValue2path({ classifyOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.value] = val.path
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(classifyOptions)
      return target
    },

    classifyLabelAfterTransformSpecial({ classifyOptionsSpecial }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.value] = val.label
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(classifyOptionsSpecial)
      return target
    },

    classifyValue2ItemSpecial() {
      const target = {}
      const _classifyOptions = this.classifyOptionsSpecial
      if (arrayIsNotEmpty(_classifyOptions)) {
        this.fnEachClassifyOptions(_classifyOptions, target)
      }
      return target
    },

    unitSpecial() {
      return this.classifyValue2ItemSpecial[this.sharingSubitemValue]?.unit || ''
    },

    // 判断节点是否是根节点-特殊
    locationNodeIsRootSpecial({ locationOptionsDynamic }) {
      const target = {}
      if (locationOptionsDynamic && locationOptionsDynamic.length) {
        locationOptionsDynamic.forEach(({ value }) => {
          if (value) {
            target[value] = true
          }
        })
      }

      return target
    },

    // 获取所选节点的子节点value
    getLocationChildNode({ locationOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = val.children.map((innerVal) => innerVal.value)
              fnValue2Label(val.children)
            } else {
              target[val.value] = [val.value]
            }
          })
        }
      }
      fnValue2Label(locationOptions)
      return target
    },

    // 获取所选节点的子节点value
    getLocationChildNodeCopy({ locationOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = val.children.map((innerVal) => innerVal)
              fnValue2Label(val.children)
            } else {
              target[val.value] = [val]
            }
          })
        }
      }
      fnValue2Label(locationOptions)
      return target
    },

    // 获取所选节点的子节点value
    isLastArea({ locationOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = false
              fnValue2Label(val.children)
            } else {
              target[val.value] = true
            }
          })
        }
      }
      fnValue2Label(locationOptions)
      return target
    },

    locationValue2Building({ locationOptions }) {
      const target = {}
      function fnTransformBuilding(options, label) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!label) {
              target[val.value] = val.label
            } else {
              target[val.value] = label
            }
            fnTransformBuilding(val.children, target[val.value])
          })
        }
      }
      locationOptions.forEach((val) => {
        target[val.value] = val.label
        fnTransformBuilding(val.children, val.label)
      })
      return target
    },

    locationValueToGranularity({ locationOptions }) {
      const target = {}
      function fnTransformGranularity(options, granularity) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!granularity) {
              target[val.value] = val?.granularity
            } else {
              target[val.value] = granularity
            }
            fnTransformGranularity(val?.children, target[val.value])
          })
        }
      }
      locationOptions.forEach((val) => {
        target[val.value] = val.granularity
        fnTransformGranularity(val?.children, val.granularity)
      })
      return target
    },

    locationValueToAnomGranularity({ locationOptions }) {
      const target = {}
      function fnTransformAnomGranularity(options, anom_granularity) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!anom_granularity) {
              target[val.value] = val?.anom_granularity
            } else {
              target[val.value] = anom_granularity
            }
            fnTransformAnomGranularity(val?.children, target[val.value])
          })
        }
      }

      locationOptions.forEach((val) => {
        target[val.value] = val.anom_granularity
        fnTransformAnomGranularity(val?.children, val.anom_granularity)
      })
      return target
    },

    locationValueToAnomGranularityDynamic({ locationOptionsDynamic }) {
      const target = {}
      function fnTransformAnomGranularity(options, anom_granularity) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!anom_granularity) {
              target[val.value] = val?.anom_granularity
            } else {
              target[val.value] = anom_granularity
            }
            fnTransformAnomGranularity(val?.children, target[val.value])
          })
        }
      }

      locationOptionsDynamic.forEach((val) => {
        target[val.value] = val.anom_granularity
        fnTransformAnomGranularity(val?.children, val.anom_granularity)
      })
      return target
    },

    // 这个方法有问题，之前是用value转，现在应该改成用key转，调用的地方也要改
    locationValue2RootValue({ locationOptions }) {
      const target = {}
      function fnTransformBuilding(options, rootValue) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!rootValue) {
              target[val.value] = val.value
            } else {
              target[val.value] = rootValue
            }
            fnTransformBuilding(val.children, target[val.value])
          })
        }
      }
      locationOptions.forEach((val) => {
        target[val.value] = val.value
        fnTransformBuilding(val.children, val.value)
      })
      return target
    },

    locationValue2AllValue({ locationOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = val
              fnValue2Label(val.children)
            } else {
              target[val.value] = val
            }
          })
        }
      }
      fnValue2Label(locationOptions)
      return target
    },

    locationValue2AllValueDynamic({ locationOptionsDynamic }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = val
              fnValue2Label(val.children)
            } else {
              target[val.value] = val
            }
          })
        }
      }
      fnValue2Label(locationOptionsDynamic)
      return target
    },

    locationValue2BuildingDynamic({ locationOptionsDynamic }) {
      const target = {}
      function fnTransformBuilding(options, label) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!label) {
              target[val.value] = val.label
            } else {
              target[val.value] = label
            }
            fnTransformBuilding(val.children, target[val.value])
          })
        }
      }
      locationOptionsDynamic.forEach((val) => {
        target[val.value] = val.label
        fnTransformBuilding(val.children, val.label)
      })
      return target
    },

    locationValue2ApmOrgId({ locationOptions }) {
      const target = {}
      function fnTransformApmOrgId(options, apmOrgId) {
        if (options && options.length) {
          options.forEach((val) => {
            if (!apmOrgId) {
              target[val.value] = val.apm_org_id
            } else {
              target[val.value] = apmOrgId
            }
            fnTransformApmOrgId(val.children, target[val.value])
          })
        }
      }
      fnTransformApmOrgId(locationOptions, '')
      return target
    },

    locationValue2children({ locationOptions }) {
      const target = {}
      function fnTransformChildren(options) {
        if (options && options.length) {
          options.forEach((val) => {
            if (val.children && val.children.length) {
              target[val.value] = val.children
            } else {
              target[val.value] = []
            }
            fnTransformChildren(val.children)
          })
        }
      }
      fnTransformChildren(locationOptions)
      return target
    },

    classifyValue2AllValue({ classifyOptions }) {
      const target = {}
      const arr = []
      function fnValue2Label(input, arr) {
        input.forEach((val) => {
          const newArr = [...arr]
          newArr.push(val.value)
          target[val.value] = newArr
          if (val.children) {
            fnValue2Label(val.children, newArr)
          }
        })
      }
      fnValue2Label(classifyOptions, arr)
      return target
    },

    classifyLabelAfterTransform({ classifyOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.value] = val.label
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(classifyOptions)
      return target
    },

    classifyValue2children({ classifyOptions }) {
      const target = {}
      function fnTransformChildren(options) {
        if (options && options.length) {
          options.forEach((val) => {
            if (val.children && val.children.length) {
              target[val.value] = val.children
            } else {
              target[val.value] = []
            }
            fnTransformChildren(val.children)
          })
        }
      }
      fnTransformChildren(classifyOptions)
      return target
    },

    // 判断节点是否是根节点
    classifyNodeIsRoot({ classifyOptions }) {
      const target = {}
      classifyOptions.forEach(({ value }) => {
        if (value) {
          target[value] = true
        }
      })
      return target
    },

    // 获取所选节点的子节点value
    getClassifyChildNode({ classifyOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = val.children.map((innerVal) => innerVal.value)
              fnValue2Label(val.children)
            } else {
              target[val.value] = [val.value]
            }
          })
        }
      }
      fnValue2Label(classifyOptions)
      return target
    },

    isLastSubitem({ classifyOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            if (val.children) {
              target[val.value] = false
              fnValue2Label(val.children)
            } else {
              target[val.value] = true
            }
          })
        }
      }
      fnValue2Label(classifyOptions)
      return target
    },

    timezoneTarget({ timezoneAfter, dayOfStartAfter, dayOfStartMinute, dayOfStartHour }) {
      return function (time, interval) {
        if (time) {
          let timestamp = transformUtcByTimezone({ time, timezone: timezoneAfter }).getTime()
          if (interval === 'minute') {
            timestamp += dayOfStartMinute
          } else if (interval === 'hour') {
            timestamp += dayOfStartHour
          } else {
            // const difference = dayOfStartAfter * 60 * 60 * 1000
            timestamp += dayOfStartAfter
          }

          return new Date(timestamp).toISOString()
        }
        return time
      }
    },

    timezoneSharing({ timezoneAfter, dayOfStartAfter, dayOfStartMinute, dayOfStartHour }) {
      return function ({ time, interval, dayOfStart = true }) {
        if (time) {
          let timestamp = transformUtcByTimezone({ time, timezone: timezoneAfter }).getTime()
          if (dayOfStart) {
            if (interval === 'minute') {
              timestamp += dayOfStartMinute
            } else if (interval === 'hour') {
              timestamp += dayOfStartHour
            } else {
              // const difference = dayOfStartAfter * 60 * 60 * 1000
              timestamp += dayOfStartAfter
            }
          }

          return new Date(timestamp).toISOString()
        }
        return time
      }
    },

    // 暂时保留，做参考
    // timezoneTarget({ interval }) {
    //   let target = 0
    //   if (this.timezone !== '') {
    //     target = (0 - this.timezone) * 60 * 60 * 1000
    //   }

    //   // flag 判断时间是否受interval影响 注：峰平谷不受影响
    //   return function (input, flag = true) {
    //     if (flag) {
    //       if (interval === 'hour' || interval === 'minute') {
    //         return new Date(new Date(input).getTime() + target).toISOString()
    //       } else {
    //         return input
    //       }
    //     } else {
    //       return new Date(new Date(input).getTime() + target).toISOString()
    //     }
    //   }
    // },

    // 工厂id转文字
    factoryIdToName({ factoryOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.node_id] = val.name
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(factoryOptions)
      return target
    },

    // 工厂item
    factoryItem({ factoryOptions, sharingFactoryValue }) {
      const obj = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            obj[val.node_id] = val
          })
        }
      }
      fnValue2Label(factoryOptions)
      let target = ''
      if (obj && sharingFactoryValue) {
        target = obj[sharingFactoryValue]
      }
      return target
    },

    // 工厂下的仪表（包含工厂）
    factoryMeter({ factoryItem }) {
      const target = []
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target.push(val)
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      if (factoryItem && factoryItem?.node_id) {
        target.push(factoryItem)
        if (factoryItem.children && factoryItem.children?.length) {
          fnValue2Label(factoryItem.children)
        }
      }
      return target
    },

    // 仪表node_id转name
    meterNodeIdToName({ factoryMeter }) {
      const target = {}
      if (factoryMeter && factoryMeter?.length) {
        factoryMeter.forEach(({ node_id, name }) => {
          target[node_id] = name
        })
      }
      return target
    },

    // 分摊-分类分项转item
    sharingSubitemItem({ sharingSubitemOptions, sharingSubitemValue }) {
      const obj = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            obj[val.value] = val
          })
        }
      }
      fnValue2Label(sharingSubitemOptions)
      let target = ''
      if (obj && sharingSubitemValue) {
        target = obj[sharingSubitemValue]
      }
      return target
    },

    defaultDepartment({ sharingSubitemValue, factoryItem }) {
      const _children = factoryItem?.children
      const target = []
      if (_children && _children?.length) {
        const fnValue2Label = (input, parent_factory_id?) => {
          if (input && input.length) {
            input.forEach(
              ({ node_id, parent_id, org_id, node_type, children, grade, name, sort_num }) => {
                let factoryId = parent_factory_id
                if (!parent_factory_id) {
                  factoryId = parent_id
                }
                if (node_type && node_type === APPORTION_DEPARTMENT) {
                  if (grade && grade <= 1) {
                  } else {
                    const obj = {
                      node_id,
                      factory_id: factoryId,
                      org_id,
                      name,
                      sort_num,
                      subitem_code: sharingSubitemValue || ''
                    }
                    target.push(obj)
                  }
                }
                if (children) {
                  fnValue2Label(children, factoryId)
                }
              }
            )
          }
        }
        fnValue2Label(_children)
      }

      return sortTable(target)
    },

    // 工厂名称转产线信息
    factoryCodeToLine({ productionLineList }) {
      const target = {}
      if (productionLineList && productionLineList?.length) {
        productionLineList.forEach(({ factory_code, line }) => {
          if (factory_code && line) {
            target[factory_code] = line
          }
        })
      }
      return target
    },

    // 选中工厂的产线
    currentFactoryLineOptions({ factoryCodeToLine, factoryItem }) {
      const factoryCode = factoryItem?.node_code
      let target = []
      if (factoryCodeToLine && factoryCode) {
        target = factoryCodeToLine[factoryCode]
      }
      return target
    },

    // 产线code转name
    lineCodeToProduct({ currentFactoryLineOptions }) {
      const target = {}
      if (currentFactoryLineOptions && currentFactoryLineOptions?.length) {
        currentFactoryLineOptions.forEach((val) => {
          target[val.line_code] = val.product
        })
      }
      return target
    },

    // 分摊-工段code转name
    workSectionCodeToAllCode({ workSectionOptions }) {
      const target = {}
      const arr = []
      function fnValue2Label(input, arr) {
        input.forEach((val) => {
          const newArr = [...arr]
          let code = val.code
          if (code.includes(',')) {
            code = code.split(',')[0]
          }
          newArr.push(code)
          target[val.code] = newArr
          if (val.children) {
            fnValue2Label(val.children, newArr)
          }
        })
      }
      fnValue2Label(workSectionOptions, arr)
      return target
    },

    // 分摊-工段code转item
    workSectionCodeToItem({ workSectionOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.code] = val
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(workSectionOptions)
      return target
    },

    // 分摊-工段code转name
    workSectionCodeToName({ workSectionOptions }) {
      const target = {}
      function fnValue2Label(input) {
        if (input && input.length) {
          input.forEach((val) => {
            target[val.code] = val.name
            if (val.children) {
              fnValue2Label(val.children)
            }
          })
        }
      }
      fnValue2Label(workSectionOptions)
      return target
    }
  },

  actions: {
    clearEcoData() {
      this.locationOptions = []
      this.locationKPIOptions = []
      this.locationOptionsDynamic = []
      this.classifyOptions = []
      this.classifyOptionsSpecial = []
      this.factoryOptions = []
      this.timezone = ''
      this.dayOfStart = ''
      this.outPutUnit = []
      this.priceUnit = []
      this.needSyncGroup = true
      localStorage.removeItem('ecowatch_wholeConfig')
    },

    setLocationUsedOptions(locationUsedOptions: any) {
      this.locationUsedOptions = locationUsedOptions
    },

    setLocationKPIOptions(locationKPIOptions: any) {
      this.locationKPIOptions = locationKPIOptions
    },

    fnEachClassifyOptions(options, target) {
      options.forEach((val) => {
        const _obj = {
          value: val.value,
          label: val.label,
          unit: val.unit,
          name: val.name
        }
        target[val.value] = _obj

        if (arrayIsNotEmpty(val.children)) {
          this.fnEachClassifyOptions(val.children, target)
        }
      })
    },
    setDefaultCheckArr(defaultCheckArr: any) {
      this.defaultCheckArr = defaultCheckArr
    },
    setAreaValue(areaValue: any) {
      this.areaValue = areaValue
    },
    setInterval(interval: any) {
      this.interval = interval
    },
    setFormInline(formInline: any) {
      this.formInline = formInline
    },
    setLocationValue(locationValue: any) {
      this.locationValue = locationValue
    },

    setLocationOptions(locationOptions: any) {
      this.locationOptions = locationOptions
    },

    setClassifyOptions(classifyOptions: any) {
      this.classifyOptions = classifyOptions
    },

    setClassifyValue(classifyValue: any) {
      this.classifyValue = classifyValue
    },

    setBeginTime(beginTime: any) {
      this.beginTime = beginTime
    },

    setEndTime(endTime: any) {
      this.endTime = endTime
    },

    setStateType(stateType: any) {
      this.stateType = stateType
    },

    setConversionType(matrixingType: any) {
      this.matrixingType = matrixingType
    },

    setKpiType(translateType: any) {
      this.translateType = translateType
    },

    changeState({ key, value }) {
      this[key] = value
    }
  }
})

export const useEcoStore = () => {
  return useLocaleStore(store)
}
